import React, { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import {
  TrendingUp,
  Home,
  School,
  AttachMoney,
  Assessment,
} from '@mui/icons-material';
import UserAppBar from './UserAppBar';
import { getCurrentUser } from '../services/accountService';

function Dashboard() {
  const [userData, setUserData] = useState(null);

  const fetchUserData = useCallback(async () => {
    try {
      // getCurrentUser routes a 401 through sessionExpiry, which clears the
      // session and hard-redirects, so there is no 401 branch to write here.
      setUserData(await getCurrentUser());
    } catch (error) {
      console.error('Failed to fetch user data:', error);
    }
  }, []);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  const features = [
    {
      title: 'Retirement Planning',
      description: 'Plan your retirement savings and track your progress',
      icon: <TrendingUp sx={{ fontSize: 40 }} />,
      color: '#00b9ad',
      action: () => console.log('Retirement Planning'),
    },
    {
      title: 'Home Buying',
      description: 'Calculate affordability and plan your home purchase',
      icon: <Home sx={{ fontSize: 40 }} />,
      color: '#007a9a',
      action: () => console.log('Home Buying'),
    },
    {
      title: 'Education Savings',
      description: 'Plan for education expenses and 529 savings',
      icon: <School sx={{ fontSize: 40 }} />,
      color: '#4fa9bb',
      action: () => console.log('Education Savings'),
    },
    {
      title: 'Financial Goals',
      description: 'Set and track your financial goals',
      icon: <AttachMoney sx={{ fontSize: 40 }} />,
      color: '#00b9ad',
      action: () => console.log('Financial Goals'),
    },
    {
      title: 'Risk Assessment',
      description: 'Assess your risk tolerance and get portfolio recommendations',
      icon: <Assessment sx={{ fontSize: 40 }} />,
      color: '#007a9a',
      action: () => console.log('Risk Assessment'),
    },
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <UserAppBar />

      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
            {/* common.ToUserDTO serialises this as `first_name`; the old
                `firstName` was always undefined, so the name never rendered. */}
            Welcome back{userData?.first_name ? `, ${userData.first_name}` : ''}!
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Choose a financial planning tool to get started
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  },
                }}
                onClick={feature.action}
              >
                <CardContent sx={{ flexGrow: 1, textAlign: 'center', py: 3 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      mb: 2,
                      color: feature.color,
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper sx={{ mt: 4, p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Quick Actions
          </Typography>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid>
              <Button variant="outlined" color="primary">
                View Goals
              </Button>
            </Grid>
            <Grid>
              <Button variant="outlined" color="primary">
                Add Associated Person
              </Button>
            </Grid>
            <Grid>
              <Button variant="outlined" color="primary">
                Financial Calculators
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default Dashboard;